/**
 * token前缀
 */
export const AUTHORIZATION_PREFIX = 'Bearer ';
/**
 * 登录token
 */
export const ACCESS_TOKEN = 'access_token';
/**
 * 登录状态
 */
export const LOGIN_STATUS = 'login_status';
/**
 * 已登录
 */
export const LOGINED = 'logined';
